module.exports = __webpack_public_path__ + "static/banner-sobre-4657812f0d8664433f3b67542b784399.jpg";